import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { v4 as uuidv4 } from "uuid";
import { RootState } from "../../../stores/store";
import { getTransactionId } from "../transactionIdApiExt";

export const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.PROD ? "/" : window.location.origin,
  prepareHeaders: (headers, { getState }) => {
    const rootState = getState() as RootState;

    headers.set("X-Transaktions-ID", getTransactionId(rootState));
    headers.set("X-Request-ID", uuidv4());

    const token = rootState.authSlice.initializeToken?.access_token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});
